/** @jsx jsx */
import { Box, jsx } from "theme-ui"
import AppStoreBadges from "../components/AppStoreBadges"
import FeatureBox from "../components/feature-box"
import Heading from "../components/heading"
import Layout from "../components/layout"
import Text from '../components/text'

const tours = [
    [
        'Absence Imagination', 
        `You've likely looked at a sculpture many times, but have you ever looked through it? Join Anna Murphy as she takes you on a compelling tour to consider what stories lie in the spaces in between.`, 
        'https://images.ctfassets.net/364ce7z8uh01/4TeOJyGf17GSixkHOG28zJ/c2938a6ca3b941f2ea875fe654b51530/Tour_Menu_Graphic_Anna.jpg',
    ], [
        'Art in Action', 
        'Public art has been at the centre of many a protest, performance and gathering. How do these pieces inspire action and spark creativity that connects us across time and space? Join Candice Pike for a journey of discovery.',
        'https://images.ctfassets.net/364ce7z8uh01/74DtAODsrefbWrrxOF6vlD/b654ad7f141d5b54799c1f2e633b1d68/Tour_Menu_Graphic_Candice.jpg',
    ], [
        'The Public Art of Luben Boykov in Newfoundland and Labrador',
        `Join Jane Walker for this enlightening look into the works of the prolific Bulgarian artist, and learn how they've contributed to the creative and cultural landscape of the province`,
        'https://images.ctfassets.net/364ce7z8uh01/3wcCogB99EfhsognCAM2Sb/33f8c60e3c4454dba6fa2fd99a1506a6/Tour_Menu_Graphic_Jane.jpg',
    ], [
        'Mural Explorations',
        'Murals colour our world while helping us make sense of it all. Take a tour with Tanea Hynes to discover some of the pieces in your own backyard that invite you to look at life through a different lens.',
        'https://images.ctfassets.net/364ce7z8uh01/nI4puv2sLN5MjTLMUd05I/3d2d5ff615236ceb9fc1d8f91c22fa31/Tour_Menu_Graphic_Tanea.jpg',
    ], [
        'Reconsidering our Monuments',
        `Monuments memorialize people and events, but sometimes, they're also a painful reminder of a dark and oppressive history. In this thought-provoking tour, Emily Critch sheds light on this timely topic.`,
        'https://images.ctfassets.net/364ce7z8uh01/6CXJH4phZTZY2WfGOkXous/e92e853866006616586eb9a057f93837/Tour_Menu_Graphic_Emily.jpg',
    ], [
        'Female Figures in Public Art',
        `When you think of women depicted in art throughout history, what comes to mind? From Shanawdithit to Amelia Earhart, the strength, resilience and tenacity of the female figures in Rachel Gilbert's tour will make you think twice`,
        'https://images.ctfassets.net/364ce7z8uh01/1NXP4JV1gkzGPZh7epHq16/2ea616f9d1ebf5a5aec24dc3740bcc9b/Tour_Menu_Graphic_Rachel.jpg',
    ],
]

function Tours() {
    return (
        <Layout title="Tours">
            <FeatureBox>
                <Box sx={{mb: 5}}>
                    <Heading weightNormal light large>Curated Tours</Heading>
                    <Text large marginBelow light>Curated tours featuring artworks grouped thematically, with information and guiding questions by six curators from across the province..</Text>
                    <Text large light marginBelowLarge>Download the mobile app for the full versions of these tours.</Text>
                    <AppStoreBadges />
                </Box>
            </FeatureBox>
            <Box sx={{paddingY: 4, maxWidth: '745px', margin: ['0 2%', '0 auto']}}>
                <ul sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', margin: '0 -2%'}}>
                    {tours.map(([title, tour, img,]) => <li key={tour} sx={{width: ['96%', '46%'], paddingLeft: '2%', paddingRight: '2%', pb: 4}}>
                        <img src={img} sx={{maxWidth: '100%',}} />
                        <Text marginBelow>{tour}</Text>
                    </li>)}
                </ul>
            </Box>
        </Layout>
    )
}

export default Tours